module.exports = function convertDate(val) {
  var date = val;
  if (typeof date == "undefined") return;
  var month = date.slice(5);
  var year = date.slice(0, 4);
  var newDate = month + "/" + year;
  return newDate;
};
